
import { useState, useEffect } from "react"
import "./AccountDeletionCss.css"
import AnimatedText from '../../AnimatedText'


import { Box, Stack, TextField, MenuItem, Button } from "@mui/material";
// import { ToastContainer, toast } from 'react-toastify';
import toast from "react-hot-toast";
import { accountDeletionRequest } from "../../api/api";




export default function AccountDelectionMainSection() {


    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [payload, setPayload] = useState({
        appType: "",
        name: "",
        mobileNumber: "",
        location: "",
        reason: ""
    });

    console.log("payload====>", payload);
    console.log("message==>", message);
    // const notify = () => toast(message);



    const valupd = (e) => {

        if (e.target.name === "mobileNumber") {
            e.target.value = e.target.value.replace(/\D/g, "");
        }
        setPayload({ ...payload, [e.target.name]: e.target.value });
    }


    // 

    const handleSubmit = (e) => {
        e.preventDefault(); // Important: prevents page reload
        fetchAccountDeletionRequest(payload); // Pass the payload
    }


    // call accountDeletionRequest api 
    const fetchAccountDeletionRequest = async (payload) => {
        try {
            setLoading(true);
            setMessage(""); // reset message before call

            const res = await accountDeletionRequest(payload);

            if (res?.data?.status?.toLowerCase() === "success") {
                setMessage(res?.data?.message || "Request submitted successfully!");
                // setShowPopup(true); // ✅ show popup only on success
                const successMessage = res?.data?.message || "Request submitted successfully!"
                toast.success(successMessage, {
                    className: 'custom-success-toster',
                    bodyClassName: 'custom-toast-body',
                    progressClassName: 'custom-progress-bar'
                });


            } else {
                //  do nothing, no popup
                console.log("API returned failure:", res?.data);
                const errorMessage = res?.data?.message || "Something went wrong. Please try again.";
                setMessage("Something went wrong. Please try again.");
                toast.error(errorMessage);

            }
        } catch (err) {
            console.error("Error submitting help request:", err);
            //  do nothing, no message, no popup
            setMessage("Server error. Please try again later.");

            // setShowPopup(true);
            toast.error("Server error. Please try again later.");
        } finally {
            setLoading(false);
            // setShowPopup(true);
            // alert(message)
            setPayload({ appType: "", name: "", mobileNumber: "", location: "", reason: "" }); // reset form
        }
    };



    return (
        <div className="NewsMainContainer">
            {/* <div className="ourPackageUpperSection">
                <AnimatedText
                    tag="h2"
                    type="words"
                    y={30}
                    className="rb-title ourpackageTitle"
                >
                    Account Deletion Request
                </AnimatedText>
            </div> */}

            {/* <div className="DeletionContentWrapper"> */}
                <div className="Request-DeletionCard">          


                    <div className="formSection">
                        
                        <Box component="form" onSubmit={handleSubmit}
                            sx={{ maxWidth: 800, margin: '0 auto' }}>
                                <h1 class="account-deletion-title">Account Deletion Request</h1>


                            <Stack direction="column" spacing={1.5}>
                                {/* App Type */}
                                <TextField
                                    select
                                    label="App Type"
                                    name="appType"
                                    value={payload.appType}
                                    onChange={valupd}
                                    fullWidth
                                    required
                                    size="small"
                                >
                                    <MenuItem value="Android">In house app </MenuItem>
                                    <MenuItem value="iOS">Dr.app</MenuItem>
                                    <MenuItem value="Web">Patient app</MenuItem>
                                </TextField>


                                <TextField
                                    label="Name"
                                    name="name"
                                    value={payload.name}
                                    onChange={valupd}
                                    fullWidth
                                    required
                                    size="small"
                                />

                                {/* Mobile Number */}
                                <TextField
                                    label="Mobile Number"
                                    name="mobileNumber"
                                    type="tel"
                                    inputProps={{
                                        maxLength: 10,
                                        inputMode: "numeric",
                                        pattern: "[0-9]*"
                                    }}

                                    value={payload.mobileNumber}
                                    onChange={valupd}
                                    fullWidth
                                    required
                                    size="small"
                                />
                                {/* Location */}
                                <TextField
                                    label="Location"
                                    name="location"
                                    value={payload.location}
                                    onChange={valupd}
                                    fullWidth
                                    required
                                    size="small"
                                />
                                {/* Reason */}
                                <TextField
                                    label="Reason"
                                    name="reason"
                                    value={payload.reason}
                                    onChange={valupd}
                                    multiline
                                    rows={1}
                                    fullWidth
                                    required
                                    size="small"
                                />
                                {/* Submit Button */}
                                <Button
                                    type="submit"
                                    variant="contained"
                                    // onClick={notify}
                                    size="medium"
                                    sx={{
                                        mt: 1,
                                        borderRadius: 1.5,
                                        textTransform: "none",
                                        fontWeight: 600,
                                        py: 0.8
                                    }}
                                >
                                    Submit
                                </Button>
                                {/* <ToastContainer /> */}


                            </Stack>
                        </Box>
                    </div>
                </div>
            {/* </div> */}

        </div>
    )
}
